import React from 'react';
import _ from 'lodash';

var LabelWrapper = function LabelWrapper(props) {
  return /*#__PURE__*/React.createElement('div', {
    className: 'radio-button-label'
  }, props.label);
};

export var generateChildrenFromOptions = function generateChildrenFromOptions(props) {
  return _.map(props.options, function (option) {
    if (props.labelTemplate) {
      return /*#__PURE__*/React.createElement(props.labelTemplate, option);
    }

    var itemProps = _.isObject(option) ? option : {
      value: props.translateIfNeeded(option)
    };

    var updatedProps = _({}).assign(itemProps, {
      label: props.translateIfNeeded(itemProps.label || itemProps.value)
    }).defaults({
      disabled: props.disabled
    }).value();

    return /*#__PURE__*/React.createElement(LabelWrapper, updatedProps);
  });
};